import { render, staticRenderFns } from "./insurance-type.vue?vue&type=template&id=dcf87348"
import script from "./insurance-type.vue?vue&type=script&lang=js"
export * from "./insurance-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports